<template>
  <div class="layout nonuple">
    <meal-image
      v-for="(meal, i) in meals"
      :class="'sec sec-' + i"
      class="meal-jumbo"
      :key="i"
      :src="(meal && meal.imageUrl) || defaultImageUrl"
      :style="fontSizeStyle"
    >
      <div v-if="meal" class="badges">
        <div class="icon badge" v-for="badge in badges(meal)" :key="badge.name">
          <img :src="badge.icon" />
        </div>
      </div>
      <div v-if="meal" class="meal-name-box">
        <!-- prettier-ignore -->
        <div class="meal-name">{{ meal.name }} <span class="allergens">{{ allergens(meal) }}</span></div>
      </div>
      <div v-if="meal" class="meal-price-box">
        <div class="meal-price">{{ meal.price | money }} {{ currency }}</div>
      </div>
    </meal-image>
  </div>
</template>

<script>
import MealImage from "@/components/meal-image"
import { state } from "@/store"
import { allergenCodes, badgeCodes } from "@/service/meal-constants"
import { slicer } from "@/utils"

export default {
  maxMeals: 9,
  slicer: slicer.fillMaximumPerScreenWithEmpty,
  name: "layout-image-3x3",
  props: ["meals"],
  components: { MealImage },
  computed: {
    defaultImageUrl() {
      return state.project.data.defaultImage.imageUrl
    },
    fontSizeStyle() {
      switch (this.meals.length) {
        case 1:
          return "font-size: 1.13636em;"
        default:
          return "font-size: 0.85227em;"
      }
    },
    currency() {
      return state.project.data.currency
    }
  },
  methods: {
    allergens(meal) {
      return meal.allergens && allergenCodes(meal.allergens, "(", ")")
    },
    badges(meal) {
      return meal.badges && badgeCodes(meal.badges)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

$border-style: $screen-border-size $screen-border-color solid;
// ideal use case for cssgrid, but not supported on fireos5
.layout {
  background: #888;
  .sec {
    position: absolute;
  }
  &.nonuple {
    .sec-0 {
      top: 0;
      left: 0;
      width: 33.3%;
      height: 33.3%;
      border-left: $border-style;
      border-top: $border-style;
    }
    .sec-1 {
      top: 0;
      left: 33.3%;
      width: 33.3%;
      height: 33.3%;
      border-left: $border-style;
      border-top: $border-style;
    }
    .sec-2 {
      top: 0;
      left: 66.6%;
      width: 33.3%;
      height: 33.3%;
      border-left: $border-style;
      border-top: $border-style;
    }
    .sec-3 {
      top: 33.3%;
      left: 0%;
      width: 33.3%;
      height: 33.3%;
      border-left: $border-style;
      border-top: $border-style;
    }
    .sec-4 {
      top: 33.3%;
      left: 33.3%;
      width: 33.3%;
      height: 33.3%;
      border-left: $border-style;
      border-top: $border-style;
    }
    .sec-5 {
      top: 33.3%;
      left: 66.6%;
      width: 33.3%;
      height: 33.3%;
      border-left: $border-style;
      border-top: $border-style;
    }
    .sec-6 {
      top: 66.6%;
      left: 0%;
      width: 33.3%;
      height: 33.3%;
      border-left: $border-style;
      border-top: $border-style;
    }
    .sec-7 {
      top: 66.6%;
      left: 33.3%;
      width: 33.3%;
      height: 33.3%;
      border-left: $border-style;
      border-top: $border-style;
    }
    .sec-8 {
      top: 66.6%;
      left: 66.6%;
      width: 33.3%;
      height: 33.3%;
      border-left: $border-style;
      border-top: $border-style;
    }
  }
}
.meal-jumbo {
  color: $screen-text-color;
  height: 100%;
  width: 100%;
  font-family: "Arial", serif;
  .meal-number {
    position: absolute;
    left: 0.1em;
    top: 0.1em;
    background-color: rgba(238, 238, 238, 0.88);
    height: 1.5em;
    width: 1.5em;
    border-radius: 52%;
    border: #222 solid 1px;
    font-size: 4em;
    text-align: center;
  }
  .meal-name-box {
    white-space: pre-wrap;
    position: absolute;
    bottom: 0;
    left: 0;
    box-shadow: 0.1em 0.1em 0.1em 0em $screen-border-color;
    width: calc(100% - 0.8em);
    margin: 0.4em 0.4em 0.4em 0.4em;
    padding: 0.6em 0.6em 0.3em 0.6em;
    background-color: rgba($screen-label-color, 0.88);
    border-radius: 3px;
    min-height: 3.25em;
    text-shadow: -0.01em 0 $screen-border-color, 0 0.01em $screen-border-color,
      0.01em 0 $screen-border-color, 0 -0.01em $screen-border-color;
    .meal-name {
      line-height: 0.85em;
      font-size: 1.8em;
      font-weight: 400;
    }
    .allergens {
      font-size: 0.5em;
      vertical-align: super;
    }
  }
  .meal-price-box {
    position: absolute;
    right: 0.4em;
    top: 0.4em;
    background-color: rgba($screen-label-color, 0.88);
    box-shadow: 0.1em 0.1em 0.1em 0em $screen-border-color;
    height: 5em;
    width: 10em;
    border-radius: 50%;
    padding-right: 0.5em;
    padding-left: 0.5em;
    text-shadow: -0.03em 0 $screen-border-color, 0 0.03em $screen-border-color,
      0.03em 0 $screen-border-color, 0 -0.03em $screen-border-color;
    display: flex;
    align-items: center;
    justify-content: center;
    .meal-price {
      font-size: 2.25em;
    }
  }
  .badges {
    position: absolute;
    top: 7em;
    right: 0.4em;
    width: 2.5em;
    .badge {
      padding-right: 0.25em;
      padding-bottom: 0.25em;
      height: 2.5em;
      width: 2.5em;
      filter: drop-shadow(0.1em 0.1em 0.1em $screen-border-color);
      img {
        opacity: 0.8;
        width: 100%;
        filter: grayscale(1) contrast(100);
      }
    }
  }
}
</style>
